import BigNumberCard from "./BigNumberCard";

export type BigNumberSupport =
  | "all"
  | "OPEN" | "IN_ANALYSIS" | "ANSWERED" | "FINISHED"

interface Props {
    pending: number;
    analyze: number;
    dealer: number;
    finished: number;
    selected: BigNumberSupport;
    handleType: (type: BigNumberSupport) => void;
}

const ListBigNumber = ({ pending, analyze, dealer, finished, handleType , selected}: Props) => {
    const toogle = (type: BigNumberSupport) => {
        handleType(type === selected ? "all" : type);
    }
    return (
        <div className="display-flex justify-content-center gap-5">
            <BigNumberCard
                active={selected}
                total={pending}
                type="OPEN"
                title="Pendente de análise"
                toogle={() => toogle('OPEN')}
                description="Aguardando início"
            />
            <BigNumberCard
                active={selected}
                total={analyze}
                type="IN_ANALYSIS"
                title="Em análise VWCO"
                toogle={() => toogle('IN_ANALYSIS')}
                description="Em avaliação"
            />
            <BigNumberCard
                active={selected}
                total={dealer}
                type="ANSWERED"
                title="Respondido ao dealer"
                toogle={() => toogle('ANSWERED')}
                description="Aguardando retorno"
            />
            <BigNumberCard
                active={selected}
                total={finished}
                type="FINISHED"
                title="Finalizados"
                toogle={() => toogle('FINISHED')}
                description="Concluídos"
            />
        </div>
    );
};

export default ListBigNumber;
